import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CountUp from "react-countup";
import Loader from "../Loader";
import Header_en from "./Header_en";
import Footer_en from "./Footer_en";
const Privacy_policy_en = () => {
  const StyledHeading = styled.h6`
    position: relative;
    font-size: 100px;
    color: #008bcd;

    &::before {
      content: "—";
      font-size: inherit;
      color: #008bcd;
      display: block;
    }
  `;
  // State to control visibility
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Delay the visibility of the component
    const timer = setTimeout(() => {
      setIsVisible(true); // Set to visible after the delay
    }, 200);

    return () => clearTimeout(timer); // Clean up on unmount
  }, []);
  return (
    <div>
      <div>
        <Header_en />
      </div>
      <Loader isVisible={isVisible} />
      <div>
        {/*=================================
page-title*/}
        <section
          className="page-title bg-overlay-black-60 parallax"
          data-jarallax='{"speed": 0.6}'
          /*style={{ backgroundImage: "url(/assets/images/bg/02.jpg)" }}*/
          style={{
            backgroundImage:
              "url(/assets/images/Entreprise/entreprise-prensentation.png)",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-title-name">
                  <h1>Privacy Policy</h1>
                </div>
                <ul className="page-breadcrumb">
                  <li>
                    <a href="/">
                      <i className="fa fa-home" /> HOME
                    </a>{" "}
                    <i className="fa fa-angle-double-right" />
                  </li>
                  <li>
                    <span>Privacy Policy</span>{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/*=================================
page-title */}

        <section className="privacy-policy page-section-ptb">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <h4 className="mt-30 theme-color">
                  {" "}
                  <strong>
                    {" "}
                    SACEM INDUSTRIES PRIVACY NOTICE AND LEGAL NOTICE
                  </strong>
                </h4>
                <p>
                  At SACEM Industries, respecting your fundamental rights
                  regarding data protection and privacy is an absolute priority
                  and an essential ethical commitment. In an ever-changing
                  digital environment, we are fully aware of the strategic
                  importance of safeguarding the information you entrust to us,
                  whether you are a customer, a business partner, an employee
                  accessing our internal portals, or simply a visitor to our
                  website.
                </p>
                <h4 className="mt-30 theme-color">
                  {" "}
                  <strong> 1. Intellectual Property and Copyright</strong>{" "}
                </h4>
                <p>
                  The general structure of the{" "}
                  <strong>sacemindustries.com</strong> website,,as well as the
                  software, text, databases, images (whether animated or not),
                  sounds, know-how and all other elements comprising the website
                  are the exclusive property of SACEM Industries.
                </p>
                <ul className="list list-unstyled">
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>Registered Trade Marks:</strong> The name{" "}
                      <strong> SACEM Industries</strong>, its logo, and the
                      associated slogans and graphic elements are registered
                      trade marks and are protected
                    </p>{" "}
                  </li>
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>No Reproduction Permitted: </strong> Any
                      representation, reproduction, modification, publication,
                      adaptation, translation or use, in whole or in part, of
                      the content, trademarks or the website, by any means
                      whatsoever and on any medium whatsoever, without the
                      express prior written authorisation of SACEM Industries is
                      strictly prohibited. Any unauthorised use shall be deemed
                      to constitute an infringement and shall be prosecuted in
                      accordance with the legal provisions relating to
                      intellectual property.
                    </p>{" "}
                  </li>
                </ul>
                <h4 className="mt-30 theme-color">
                  <strong>2.Terms and Conditions of Use (T&Cs)</strong>
                </h4>
                <p>
                  Use of the sacemindustries.com website implies full and
                  unconditional acceptance of these terms and conditions of use.
                  This website is normally accessible to users at all times.
                  However, SACEM Industries may decide to suspend access for
                  technical maintenance or updates, in which case it will
                  endeavour to restore the service as soon as possible.
                </p>

                <h4 className="mt-30 theme-color">
                  {" "}
                  <strong>
                    {" "}
                    3. Privacy Policy and Protection of Personal Data
                  </strong>{" "}
                </h4>
                <p>
                  SACEM Industries undertakes to ensure that the collection and
                  processing of your data via the sacemindustries.com website
                  comply with current national and international regulations on
                  the protection of personal data.
                </p>
                <ul className="list list-unstyled">
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>Data collection: </strong> Personal data is
                      collected fairly and lawfully (via contact forms,
                      authentication on secure portals, and the submission of
                      documents). It generally includes the surname, first name,
                      work email address and login credentials.
                    </p>{" "}
                  </li>
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>Purpose of the processing: </strong> The
                      information collected is intended solely for use by SACEM
                      Industries for the purposes of managing commercial
                      relations, the operation of internal platforms (management
                      of roles and authorisations), and technical support. Under
                      no circumstances will this data be transferred, sold or
                      leased to third parties.
                    </p>{" "}
                  </li>
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>Data security: </strong> SACEM Industries
                      implements rigorous technical and organisational security
                      measures to protect your data against destruction, loss,
                      alteration, unauthorised disclosure or access.
                    </p>{" "}
                  </li>
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>Exercising your rights: </strong>You have the
                      right to access, rectify, restrict the processing of,
                      object to and erase your personal data. To exercise these
                      rights, please send your request by email to:{" "}
                      <strong>contact@sacemindustries.com </strong>
                      or by post to the registered office.
                    </p>{" "}
                  </li>
                </ul>
                <h4 className="mt-30 theme-color">
                  <strong>4. Cookie Policy</strong>
                </h4>
                <p>
                  Browsing the sacemindustries.com website may result in one or
                  more cookies being stored on the user’s device.
                </p>
                <ul className="list list-unstyled">
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>Types of cookies: </strong>A cookie is a small
                      file that stores information relating to a computer’s
                      browsing activity on a website (user session management,
                      dashboard statistics, saving preferences).
                    </p>
                  </li>
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>Purpose: </strong> The cookies used by SACEM
                      Industries are intended solely to facilitate navigation,
                      secure access to private areas and measure the website’s
                      audience in order to improve its performance.
                    </p>
                  </li>
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>Consent and settings: </strong> On your first
                      visit, a banner will inform you about the use of cookies.
                      You can configure your browser to block the installation
                      of certain cookies that are not essential to the
                      functioning of the website.
                    </p>
                  </li>
                </ul>
                <h4 className="mt-30 theme-color">
                  <strong>5. Governing Law and Competent Jurisdiction</strong>
                </h4>
                <p>
                  Any dispute arising in connection with the use of the
                  sacemindustries.com website shall be governed by the
                  applicable law in force. Except where prohibited by law,
                  exclusive jurisdiction is hereby conferred on the competent
                  courts of the place where SACEM Industries has its registered
                  office.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div>
        <Footer_en />
      </div>
    </div>
  );
};

export default Privacy_policy_en;
